
import { updateDoc,doc } from 'firebase/firestore'  
import { db } from './firebase-config';

const UpdateData = async (id,data,name)=>{
    const newDoc = doc(db,name,id);
    await updateDoc(newDoc,data);
}
export default UpdateData